import dyLoaded from './dy-loaded';
import trackEvent from './dy-track-event';

export default async function trackNewsletter(email) {
  try {
    await dyLoaded();
    const eventData = {
      dyType: 'newsletter-subscription-v1',
      hashedEmail: DYO.dyhash.sha256(email),
    };
    await trackEvent('Newsletter Subscription', eventData);
    return Promise.resolve();
  } catch (e) {
    console.error('Error tracking event', e);
    return Promise.reject(e);
  }
}
